<!--

Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Vijay Malekar

-->
<!--Top Section-->
<div class="container-fluid">
    <div class="row" style="padding-left: 0;">
        <div class="col-md-12" style="padding-left: 0;">
            <h1  id="headings" class="main-headings">Cisco Application Detector Support</h1>
        </div>
    </div>
</div>

            
  <div class="small-container-white" style="padding-top: 15px; padding-bottom: 15px; margin-top: 15px;"> 
     <div class="row">
        <div class="col-md-12">
            <button class="btn btn--primary" (click)="submit()"   >Open a case with Cisco Support</button>
        </div>
    </div>
  </div>
  

  <div class="small-container-white" style="padding-top: 10px; padding-bottom: 10px;"> 
    <div class="row">
        <div class="col-md-12">
            <p><b>Troubleshooting Steps for TAC.</b></p>
            In general, application detection issues can be caused by either: 
            <li>A change in the server's behavior or traffic. </li>
            <li>A recent update in the VDB that caused the detection behavior to change.</li>

            <p><b>Please make sure that the following steps have been considered prior to opening a TAC case:</b></p>
            <li>Make sure you have the latest VDB installed and test again. The latest VDB release is the one listed in our <u><a href="https://appid.cisco.com/relnotes" target="_blank">Release Notes</a></u> page.</li> 
            <li>Document when this detector was last working fine, either if it was prior to a new VDB or a recent product upgrade.</li>  
            <li>Is the issue you're seeing easily reproducible? If so, please document the steps to reproduce it.</li> 

            <p>
                <b>If either of these issues are still there, and we still need to open a TAC case, then we may need to prepare having to capture some traffic to identify this problem closer:</b> 
            </p>
            <li>Start capturing the traffic from the client side (laptop, end user’s endpoint), before the app starts, stop after the app ends. </li>
            <li>Start the "system support application-identification-debug" CLI from the sensors using the client's IP address.</li>

            <p>
                <b>If we're having issues with the access control rules for this application, having some additional traces would be helpful.</b> 
            </p>
            <li>Some of the tools that can be used for capturing more traces are:</li>

            <p><b>From the Sensors CLI capture the following logs from the either of these commands: </b></p>
            <li>System support firewall-engine-debug.</li>
            <li>Support trace </li>
          </div>
         </div>
       </div>    


       
  <div class="small-container-white" style="padding-top: 10px; padding-bottom: 10px;"> 
    <div class="row">
        <div class="col-md-12">
            <p><b>Troubleshooting steps from the Firepower Management Center: </b></p>
            
            <dl>
                <dt><b>Use the “Packet Capture” UI:</b> </dt>
                <dd><li>Depending on the application's usage, we may need to increase the buffer options to capture all traffic.</li> </dd>
                <dd><li>Enable circular buffer capture in case this application is causing large data dumps and it’s not easily reproducible.</li></dd>
                <dd><li>Enable Trace.</li></dd>
                <dd><li>Save pcap formats.</li></dd>
                <dd><li>Save text format if there are issues blocking the application.</li></dd>
            </dl>

            <li>When all the captures are done, were you able to verify that all the capture traffic you were expecting is included in the files you generated </li>

            <p><b>From the “Connection Events” UI</b> </p>
            <li>Look into exporting the connection events for the traffic that shows these issues. </li>
        </div>
      </div>  
   </div>


<footer class="footer" style="margin-top: 35px;">
    <div class="footer__legal">
        <div class="row">
            <div class="col-md-2">
                @ 2023 Cisco Systems, Inc.
            </div>
            <div class="col-md-6">

            </div>
            <div class="col-md-4">
                <a href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html" style="padding-left: 185px;
                font-weight: 700;color: #1D69CC;">Privacy policy</a>
            
                <a href="https://www.cisco.com/c/en/us/about/legal/terms-conditions.html" style="padding-left: 18px;
                font-weight: 700;color: #1D69CC;">Terms of service</a>
            </div>    
        </div>
    </div>
</footer>